import React from 'react';
import styles from './popout-container.css';
import { PopoutContainerProps, containerStyles } from './popout-helpers';
import { Marker } from './popout-marker';
import classNames from 'classnames';

const PopoutContainer = ({
  type,
  geometry,
  children,
  style: styleOverrides,
  containerRef: ref,
  containerWidth,
  light,
  ...rest
}: PopoutContainerProps) => (
  <div
    className={classNames(styles.container, {
      [styles.light]: light
    })}
    data-testid="popout-container"
    style={containerStyles(containerWidth, geometry, styleOverrides)}
    ref={ref}
    {...rest}
  >
    <Marker geometry={geometry} light={light} />
    <div className={classNames([styles.content, styles[type]])} data-testid="flyout-items">
      {children}
    </div>
  </div>
);

export default PopoutContainer;
